<form>
    <input type="file" name="file" id="file" class="form-control" accept=".csv" (change)="onFileChange($event)" />
</form>


<table class="table mt-4 table-striped">
    <thead>
        <tr>
            <th>condominio</th>
            <th>torre</th>
            <th>depto</th>
            <!-- th>precio</!-->
            <!-- th>factor</!-->
            <!-- th>lecturaAnterior</!-->
            <!-- th>lecturaActual</!-->
            <!-- th>consumoLt</!-->
            <th>consumo</th>
            <th>descuento</th>
            <th>admon</th>
            <th>adeudo</th>
            <!-- th>reconx</!-->
            <th>subtotal</th>
            <th>iva</th>
            <th>total</th>
            <!-- th>refrerencia</!-->
            <th>periodoInicio</th>
            <th>periodoFin</th>
            <!-- th>dias</!-->
            <!-- th>fecha</!-->
        </tr>
    </thead>
    
<tbody *ngFor="let recibo of recibos">
    <tr>
        <td>{{recibo.condominio}}</td>
        <td>{{recibo.torre}}</td>
        <td>{{recibo.depto}}</td>
        <!-- td>{{recibo.precio}}</!-->
        <!-- td>{{recibo.factor}}</!-->
        <!-- td>{{recibo.lecturaAnterior}}</!-->
        <!-- td>{{recibo.lecturaActual}}</!-->
        <!-- td>{{recibo.consumoLt}}</!-->
        <td>{{recibo.consumo}}</td>
        <td>{{recibo.descuento}}</td>
        <td>{{recibo.admon}}</td>
        <td>{{recibo.adeudo}}</td>
        <!-- td>{{recibo.reconx}}</!-->
        <td>{{recibo.subtotal}}</td>
        <td>{{recibo.iva}}</td>
        <td>{{recibo.total}}</td>
        <!--td>{{recibo.refrerencia}}</td -->
        <td>{{recibo.periodoInicio}}</td>
        <td>{{recibo.periodoFin}}</td>
        <!-- td>{{recibo.dias}}</td -->
        <!-- td>{{recibo.fecha}}</!-->
    </tr>
</tbody>
</table>

<div class="mt-4">
<button class="btn btn-primary btn-lg rounded-5" (click)="generarRecibos()" [disabled]="this.recibos.length == 0">Generar recibos</button>
</div>